/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { ExtraOptions, RouterModule, Routes } from '@angular/router';

import { NbLoginComponent } from './components/login/login.component';
import { NbLogoutComponent } from './components/logout/logout.component';
import { NgModule } from '@angular/core';

// ATTENTION
/* currently not lazy loading the auth module, paths are checked by app-routing module ! */

export const routes: Routes = [
  {
    path: 'logout',
    component: NbLogoutComponent,
  },
  /* {
    path: '',
    component: NbLoginComponent,
    children: [
      {
        path: 'login',
        component: NbLoginComponent,
      },
      {
        path: 'register',
        component: NbRegisterComponent,
      },
      {
        path: 'logout',
        component: NbLogoutComponent,
      },
      {
        path: 'forgot-password',
        component: NbForgotPasswordComponent,
      },
      {
        path: 'reset-password',
        component: NbResetPasswordComponent,
      },
    ],
  }, */
  {
      path: 'login',
      component: NbLoginComponent,
  },
  
  /* { path: '', redirectTo: 'auth/login', pathMatch: 'prefix' }, */

];

const config: ExtraOptions = {
  useHash: false,
};
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {
}

